module.exports = __webpack_public_path__ + "img/jaune.625504ee.png";